"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigurationZugentlastungUtil = void 0;
const echain_shared_configurations_1 = require("@igus/echain-shared-configurations");
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
class ConfigurationZugentlastungUtil {
    /**
     * Filters the given Zugentlastungen against the given configuration.
     */
    static filterByConfiguration(zeList, configuration) {
        var _a, _b;
        const configurationModel = configuration.toModel();
        const { type, config } = (0, echain_shared_configurations_1.asTypedConfigurationUnion)(configurationModel);
        switch (type) {
            case 'Empty':
            case 'Espool':
            case 'EspoolChild':
                return zeList.toArray();
            case 'Kette': {
                const aeTypes = config.AEs.filter((ae) => ae.ZugentlastungTyp != null).map((ae) => ae.ZugentlastungTyp);
                const serieRefKuerzel = (0, echain_shared_articles_1.isRolEchainUnionUnsafe)(config.Kette)
                    ? (_a = config.Kette.StandardLink.SerieRef) === null || _a === void 0 ? void 0 : _a.Kuerzel
                    : (_b = config.Kette.SerieRef) === null || _b === void 0 ? void 0 : _b.Kuerzel;
                return zeList.filterByKetteAndAE(serieRefKuerzel, aeTypes);
            }
            default:
                (0, echain_shared_ts_utils_1.assertUnreachable)(type);
        }
    }
}
exports.ConfigurationZugentlastungUtil = ConfigurationZugentlastungUtil;
//# sourceMappingURL=ConfigurationZugentlastungUtil.js.map